import { RangeManifest } from "reducers/slideTilesReducer";

import {
  OSD_FULLY_LOADED_CHANGE,
  SLIDE_RANGE_MANIFEST_FAILURE,
  SLIDE_RANGE_MANIFEST_REQUEST,
  SLIDE_RANGE_MANIFEST_SUCCESS,
  SLIDE_TILES_LOADED,
} from "./constants";
import { AsyncSagaAction, createAsyncSaga } from "../utils/asyncActions";

const retrieveRangeManifest = async ({
  url,
}: {
  url: string;
}): Promise<RangeManifest> => {
  // credentials: 'include" to affix cookie-based auth
  const response = await fetch(url, { credentials: "include" });
  return await response.json();
};

export const slideRangeManifest = createAsyncSaga(
  SLIDE_RANGE_MANIFEST_REQUEST,
  SLIDE_RANGE_MANIFEST_SUCCESS,
  SLIDE_RANGE_MANIFEST_FAILURE,
  ({ id }) => `slide-range-manfiest/${id}`,
  ({ url }) => retrieveRangeManifest({ url })
) as AsyncSagaAction<{ url: string; id: number }>;

export const tilesLoaded = (loaded: boolean) => ({
  type: SLIDE_TILES_LOADED,
  payload: loaded,
});

export const fullyLoadedChange = (
  fullyLoaded: OpenSeadragon.FullyLoadedChangeTiledImageEvent["fullyLoaded"]
) => ({
  type: OSD_FULLY_LOADED_CHANGE,
  payload: fullyLoaded,
});
